var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-header"},[_c('a',{staticClass:"back-header-arrow-left",on:{"click":_vm.handleClick}},[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2),_vm._t("default",function(){return [(_vm.title)?_c('div',{staticClass:"back-header-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }